var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Flex, FormLabel, IconButton, Text } from '@chakra-ui/react';
import React from 'react';
import { MinusIcon, PlusIcon } from '../../shared';
var smsButtonsStyles = {
    h: 6,
    minW: 6,
    variant: 'ghost',
};
var SmsCounter = function (_a) {
    var addPackage = _a.addPackage, minusPackage = _a.minusPackage, summarySms = _a.summarySms, isDisableMinus = _a.isDisableMinus;
    return (React.createElement(Flex, { flexDir: 'column' },
        React.createElement(FormLabel, { htmlFor: 'smsPackages' }, "SMS count"),
        React.createElement(Flex, { alignItems: 'center', bg: 'bg.pure', border: '1px solid', borderColor: 'border.pure', borderRadius: 'md', gap: '2xs', minH: 10, px: 'xs', w: 'fit-content' },
            React.createElement(IconButton, __assign({ "aria-label": 'Minus sms package', "aria-labelledby": 'Minus sms package', icon: React.createElement(MinusIcon, { boxSize: 4, color: 'icon.pure' }), isDisabled: isDisableMinus, onClick: minusPackage }, smsButtonsStyles)),
            React.createElement(Text, null,
                summarySms,
                " SMS"),
            React.createElement(IconButton, __assign({ "aria-label": 'Plus sms package', "aria-labelledby": 'Plus sms package', icon: React.createElement(PlusIcon, { boxSize: 4, color: 'icon.pure' }), onClick: addPackage }, smsButtonsStyles)))));
};
export default SmsCounter;
//# sourceMappingURL=SmsCounter.js.map